const $ = require('jquery')
const _ = require('underscore')

require('tpl')
const infoboxTpl = require('../Block/infobox.html.twig')

const Infobox = function Infobox(text, options) {
  const params = _.defaults(options, $.infobox.options)
  let $el = params.element

  const init = function init() {
    if (_.isString(options)) {
      params.type = options
    }

    $el = params.element

    if (params.element) {
      initTemplate(params.element, true)
    } else {
      initTemplate(
        $(
          infoboxTpl({
            type: params.type,
            closeBtn: params.closeBtn,
            msg: text,
            margin: params.margin,
            className: params.className,
          }),
        ),
      )
    }
  }

  const initTemplate = function initTemplate(el, pageInit) {
    if (!el || !el.length) {
      return
    }

    $el = el
    $el.find('.infobox-icon-close').click(close)

    params.container.removeClass('hidden')

    if (!pageInit) {
      params.container.append($el)
    }

    if (params.autoHide) {
      setTimeout(close, params.autoHideTime)
    }

    if (params.animateOnStart) {
      $el.css('display', 'none').slideDown(200)
    }
  }

  const close = function close() {
    if (!$el) {
      return
    }
    $el.slideUp(params.slideSpeed, () => {
      $el.remove()
      $el = undefined
      if (params.container.children().length === 0 && params.container === $.infobox.options.container) {
        params.container.addClass('hidden')
      }
    })
  }

  if (text === undefined) {
    return text
  }

  init()

  /** PUBLIC * */
  if ($el) {
    $el.close = close
  }

  return $el
}

$.infobox = function infobox(text, options) {
  if (_.isString(options)) {
    options = { type: options }
  }
  return new Infobox(text, _.defaults(options, { margin: false }))
}

$.fn.infobox = function infobox(text, options) {
  if (_.isString(options)) {
    options = { type: options }
  }
  return new Infobox(text, $.extend({}, { container: $(this) }, options))
}

$.infobox.options = {
  container: $('#infoboxContainer'),
  type: 'notice',
  className: '',
  margin: true,
  autoHide: true,
  closeBtn: true,
  animateOnStart: true,
  autoHideTime: 10000,
  slideSpeed: 200,
}

let i = 0
if ($.infobox && $.infobox.options) {
  $.infobox.options.container.children().each(function each() {
    const $this = $(this)
    $.infobox(false, {
      element: $this,
      animateOnStart: false,
      autoHideTime: $.infobox.options.autoHideTime + (i * $.infobox.options.autoHideTime) / 2,
    })
    i++
  })
}

module.exports = Infobox
